export default class ImageWorker {
    constructor(_imageName, _context, imageCanvas) {
        this.workerFlat =  new Worker('./assets/vendor/imageWorker_flat.js');
        this.imageName = _imageName;
        this.context = _context;
        this.imageCanvas = imageCanvas;
        this.dotCount = null;
    }

    processImage() {
        return new Promise((resolve, reject) => {
            const _image = document.getElementById(this.imageName);
 

            if (!_image) {
                reject(new Error('Image element not found'));
                return;
            }

            this.context.drawImage(_image, 0, 0);
            
            const imageData = this.context.getImageData(0, 0, this.imageCanvas.width, this.imageCanvas.height);

            this.workerFlat.postMessage({ imageData: imageData.data });

            this.workerFlat.onmessage = (e) => {
                const { dotCount } = e.data;
                this.dotCount = dotCount;
                resolve(dotCount);
            };

            this.workerFlat.onerror = (err) => {
                reject(err);
            };
        });
    }
}
